import { render, staticRenderFns } from "./bose.vue?vue&type=template&id=2a1b2d12&"
import script from "./bose.vue?vue&type=script&lang=js&"
export * from "./bose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports